import LocatoinCoverageReport from "@/services/api/locationCoverageReport";
import { handleResponse } from "@/services/axios";
import { saveAsExcelFile } from "@/services/excelService/excelSevice";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface LocationCoverageReportDetails {
    locationCoverageReportDetails: any[];
    loading: {
        locationCoverageReportDetails: boolean,
        locationDistanceCoverageExport: boolean;
    };
    error: string | null;
}

const initialState: LocationCoverageReportDetails = {
    locationCoverageReportDetails: [],
    loading: {
        locationCoverageReportDetails: false,
        locationDistanceCoverageExport: false
    },
    error: null,
}

export const getLocationCoverageReportDetails = createAsyncThunk(
    "report/getLocationCoverageReportDetails",
    async (payload: any, { rejectWithValue }) => {
        try {
            const res = await LocatoinCoverageReport.getLocationCoverageDetails(payload);
            return handleResponse(res, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(err?.response?.data?.message || "Failed to fetch attendance");
        }
    }
);

export const getLocationDistanceCoverageExport = createAsyncThunk(
    "report/getLocationDistanceCoverageExport",
    async (payload: any, { rejectWithValue }) => {
        try {
            const res = await LocatoinCoverageReport.getLocationDistanceCoverageExport(payload);
            return saveAsExcelFile(res, "LOCATION_DISTANCE_COVERAGE_REPORT");
        } catch (err: any) {
            return rejectWithValue(err?.response?.data?.message || "Failed to export");
        }
    }
);

const locationCoverageReport = createSlice({
    name: "locationCoverageReport",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getLocationCoverageReportDetails.pending, (state) => {
                state.error = null;
                state.locationCoverageReportDetails = [];
                state.loading.locationCoverageReportDetails = true;
            })
            .addCase(getLocationCoverageReportDetails.fulfilled, (state, action) => {
                state.error = null;
                state.locationCoverageReportDetails = action.payload || [];
                state.loading.locationCoverageReportDetails = false;
            })
            .addCase(getLocationCoverageReportDetails.rejected, (state, action) => {
                state.error = action.payload as string;
                state.locationCoverageReportDetails = [];
                state.loading.locationCoverageReportDetails = false;
            })
            .addCase(getLocationDistanceCoverageExport.pending, (state) => {
                state.error = null;
                state.loading.locationDistanceCoverageExport = true;
            })
            .addCase(getLocationDistanceCoverageExport.fulfilled, (state) => {
                state.error = null;
                state.loading.locationDistanceCoverageExport = false;
            })
            .addCase(getLocationDistanceCoverageExport.rejected, (state, action) => {
                state.error = action.payload as string;
                state.loading.locationDistanceCoverageExport = false;
            })
    },
});

export default locationCoverageReport.reducer;